// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { RequestIdBuf } from '../datagram/request-id-buf.js';
import { FileIdBuf } from '../file/file-id-buf.js';
import { FileSha256HashBuf } from '../file/file-sha256-hash-buf.js';


export class UserThumbnailRequestDatagramBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):UserThumbnailRequestDatagramBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsUserThumbnailRequestDatagramBuf(bb:flatbuffers.ByteBuffer, obj?:UserThumbnailRequestDatagramBuf):UserThumbnailRequestDatagramBuf {
  return (obj || new UserThumbnailRequestDatagramBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsUserThumbnailRequestDatagramBuf(bb:flatbuffers.ByteBuffer, obj?:UserThumbnailRequestDatagramBuf):UserThumbnailRequestDatagramBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new UserThumbnailRequestDatagramBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

requestId(obj?:RequestIdBuf):RequestIdBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new RequestIdBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

offline():boolean {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
}

thumbnailName():string|null
thumbnailName(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
thumbnailName(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

preHash(obj?:FileIdBuf):FileIdBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? (obj || new FileIdBuf()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null;
}

checksum(obj?:FileSha256HashBuf):FileSha256HashBuf|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new FileSha256HashBuf()).__init(this.bb_pos + offset, this.bb!) : null;
}

sizeBytes():bigint {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0');
}

static startUserThumbnailRequestDatagramBuf(builder:flatbuffers.Builder) {
  builder.startObject(6);
}

static addRequestId(builder:flatbuffers.Builder, requestIdOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, requestIdOffset, 0);
}

static addOffline(builder:flatbuffers.Builder, offline:boolean) {
  builder.addFieldInt8(1, +offline, +false);
}

static addThumbnailName(builder:flatbuffers.Builder, thumbnailNameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, thumbnailNameOffset, 0);
}

static addPreHash(builder:flatbuffers.Builder, preHashOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, preHashOffset, 0);
}

static addChecksum(builder:flatbuffers.Builder, checksumOffset:flatbuffers.Offset) {
  builder.addFieldStruct(4, checksumOffset, 0);
}

static addSizeBytes(builder:flatbuffers.Builder, sizeBytes:bigint) {
  builder.addFieldInt64(5, sizeBytes, BigInt('0'));
}

static endUserThumbnailRequestDatagramBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  builder.requiredField(offset, 4) // request_id
  builder.requiredField(offset, 8) // thumbnail_name
  builder.requiredField(offset, 10) // pre_hash
  builder.requiredField(offset, 12) // checksum
  return offset;
}

}
